import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ConfigService, LoggingService, MerriCommonModule } from "@merri/common";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthInterceptor } from "./core/interceptors/auth.interceptor";
import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { AppConfigService } from "./core/services/app-config.service";
import { FooterComponent } from "./layouts/footer/footer.component";
import { HeaderComponent } from "./layouts/header/header.component";
import { PageNotFoundComponent } from "./layouts/page-not-found/page-not-found.component";
import { AuthComponent } from "./public/auth/auth.component";
import { SharedModule } from "./shared/shared.module";

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent, PageNotFoundComponent, AuthComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, SharedModule, BrowserAnimationsModule, MatTabsModule, AppRoutingModule, MerriCommonModule],
  providers: [
    { provide: ConfigService, useExisting: AppConfigService },
    [
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ],
    provideAppInitializer(() => {
      const initializerFn = ((appConfigService: AppConfigService) => {
        return () => {
          LoggingService.log(JSON.stringify(environment));
          return firstValueFrom(appConfigService.loadConfig());
        };
      })(inject(AppConfigService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
